import CInput from "../../../../components/CInput";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const CustomerSelection = ({
  details,
  setDetails,
  errObj,
  setErrObj,
  isDisabled,
}) => {
  const handleNameChange = (e) => {
    const value = e.target.value;
    setDetails((prev) => ({
      ...prev,
      username: value,
    }));
    setErrObj({
      ...errObj,
      customerNameErr: false,
      customerNameMsg: "",
    });
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setDetails((prev) => ({
      ...prev,
      customer_email: value,
    }));

    // Validate email format
    if (value && !emailRegex.test(value)) {
      setErrObj({
        ...errObj,
        customerEmailErr: true,
        customerEmailMsg: "Please enter a valid email address",
      });
    } else {
      setErrObj({
        ...errObj,
        customerEmailErr: false,
        customerEmailMsg: "",
      });
    }
  };

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <CInput
        label="Customer Name"
        placeholder="Enter customer name"
        value={details?.username || ""}
        onChange={handleNameChange}
        disabled={isDisabled}
        error={errObj.customerNameErr}
        helpertext={errObj.customerNameMsg}
        type="text"
      />
      <CInput
        label="Customer Email"
        placeholder="Enter email address"
        value={details?.customer_email || ""}
        onChange={handleEmailChange}
        error={errObj.customerEmailErr}
        helpertext={errObj.customerEmailMsg}
        disabled={isDisabled}
        type="email"
      />
    </div>
  );
};

export default CustomerSelection;
